module.exports = __webpack_public_path__ + "img/wx_qr_code.03564021.png";